import { GeneralAuthGuardFn } from './general-auth-guard';
import { HasVisitedGoOverviewGuard } from './has-visited-go-overview/has-visited-go-overview-guard';

export const GoPageCanActivateGuards = {
    CanActivate: [HasVisitedGoOverviewGuard, GeneralAuthGuardFn],
} as const;
